import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const UserService = {
  getList: async () => {
    const response = await apiService.get("/users");
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/users/register", data);
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/users/${id}`);

    return response.data;
  },
  update: async (id, updateData) => {
    try {
      const response = await apiService.put(`/users/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Error updating Universities", error);
      throw error;
    }
  },
  delete: async (id) => {
    const response = await apiService.delete(`/users/delete/${id}`);
    return response.data;
  },
};
export default UserService;
